import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Tooltip from "../../components/global/Tooltip/Tooltip";
import FormInputRadio from "../../components/global/FormInputRadio/FormInputRadio";
import Checkbox from "../../components/global/Checkbox/Checkbox";
import PaymentToken from "../../components/global/PaymentToken/PaymentToken";
import { useSelector } from "react-redux";
import { manageBillingSelector } from "../../features/managebilling/manageBillingSlice";
import { saveNote } from "../../features/notes/notesSlice";
import {
  InsertWSrequestLog,
  orderSliceSelector,
  updateWSrequestLog,
} from "../../features/orders/orderSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MethodOfPayment = ({
  t,
  register,
  formValues,
  //fields,
  ccDetails,
  setaddNewCreditCard,
  handlDropdownChange,
  setValue,
  trigger,
  firmIDAndName,
  billing,
  setCCDailog,
  setCreditCardRequest,
  submittionRef,
  paymentMethod,
  billingDetails,
  watch,
  addNewCreditCard,
  //handleChange,
  handleChangeCheckbox,
  dispatch,
  ProcessCCPayment,
  lawyerDetails,
  userID,
  fileID,
  dealtypeID,
  downloadPoliciesClick,
  dueAmount,
  invoices,
  userLogin,
  pricingInfo
}) => {
  const { CCPaymentResponse } = useSelector(manageBillingSelector);
  const { WSRequestlogID } = useSelector(orderSliceSelector);
  //let diffCCdetails=ccDetails;

  watch(billingDetails);
  watch(formValues);
  const [NewCC, setNewCC] = useState(false);
  const [diffCCdetails, setdiffCCdetails] = useState([]);
  const payNowRef = useRef(null);
  const hasInvoices = invoices !== null && invoices !== undefined;
  const handleChange = (e) => {
    e.persist();
    if (e.target.name === "diffCCRadio") {
      setaddNewCreditCard(false);
      setValue("AddnewCC", "");
      setValue("diffCCVaultKey", diffCCdetails[e.target.value]?.vaultDataKey);
      setNewCC(false);
    }
    if (e.target.name === "AddnewCC") {
      setaddNewCreditCard(true);
      setValue("diffCCRadio", "");
      setNewCC(true);
    }
    if (e.target.name === "defaultCC") {
      setaddNewCreditCard(false);
      setValue("AddnewCC", "");
      setNewCC(false);
    }
    setValue(e.target.name, e.target.value);
    trigger(e.target.name);
  };
  useEffect(() => {
    if (
      billingDetails &&
      billingDetails?.paymentMethodSetUp !== undefined &&
      billingDetails?.paymentMethodSetUp?.length > 0
    ) {
      if (
        billingDetails?.paymentInformation?.filter((x) => x.isAllDealType)
          .length > 0
      ) {
        let allDealDetails = billingDetails?.paymentMethodSetUp?.filter(
          (x) => x.dealType === 3,
        )[0];
        if (
          billingDetails?.paymentInformation?.filter((x) => x.isAllDealType)[0]
            ?.id === allDealDetails?.billingID
        ) {
          //   setValue(`payment.${0}.paymentMethod`, allDealDetails ? allDealDetails?.billingID : 0)
          //   setValue(`payment.${0}.billing`, allDealDetails ? allDealDetails?.billingTypeID.toString() : '')
          //   setValue(`payment.${0}.frequency`, allDealDetails ? allDealDetails?.billingFrequency.toString() : '')
          //   setValue(`payment.${0}.dealType`, !allDealDetails ? 3 : allDealDetails?.dealType)
          var maskedcardnumber = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.maskedCardNumber;
          var expiryMnth = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.expiryMonth;
          var expiryYear = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.expiryYear;
          var vaultDataKey = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.vaultDataKey;
          setValue(`defaultCCNumber`, maskedcardnumber);
          setValue(`defaultCCExpiryDate`, expiryMnth + "/" + expiryYear);
          setValue(`defaultCCVaultKey`, vaultDataKey);
        }
        // diffCCdetails = ccDetails && ccDetails?.length > 0 && ccDetails?.filter((x) => x.isAllDealType == false);
        setdiffCCdetails(ccDetails?.filter((x) => x.isAllDealType == false));
        // else {
        //   setValue(`payment.${0}.paymentMethod`, 0)
        //   setValue(`payment.${0}.billing`, '')
        //   setValue(`payment.${0}.frequency`, '')
        //   setValue(`payment.${0}.dealType`, 0)
        // }
      } else {
        let allDealDetails = billingDetails?.paymentMethodSetUp?.filter(
          (x) => x.dealType === dealtypeID,
        )[0];
        if (
          billingDetails?.paymentInformation?.filter(
            (x) => x?.id === allDealDetails?.billingID,
          )
        ) {
          //   setValue(`payment.${0}.paymentMethod`, allDealDetails ? allDealDetails?.billingID : 0)
          //   setValue(`payment.${0}.billing`, allDealDetails ? allDealDetails?.billingTypeID.toString() : '')
          //   setValue(`payment.${0}.frequency`, allDealDetails ? allDealDetails?.billingFrequency.toString() : '')
          //   setValue(`payment.${0}.dealType`, !allDealDetails ? 3 : allDealDetails?.dealType)
          var maskedcardnumber = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.maskedCardNumber;
          var expiryMnth = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.expiryMonth;
          var expiryYear = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.expiryYear;
          var vaultDataKey = billingDetails?.paymentInformation?.filter(
            (x) => x.id === allDealDetails?.billingID,
          )[0]?.vaultDataKey;
          setValue(`defaultCCNumber`, maskedcardnumber);
          setValue(`defaultCCExpiryDate`, expiryMnth + "/" + expiryYear);
          setValue(`defaultCCVaultKey`, vaultDataKey);
          //diffCCdetails = ccDetails?.filter((x) => x.id !== allDealDetails?.billingID);
          setdiffCCdetails(
            ccDetails?.filter((x) => x.id !== allDealDetails?.billingID),
          );
        }
      }
    }
  }, [billingDetails]);

  useEffect(() => {
    if (CCPaymentResponse !== null) {
      if (WSRequestlogID !== 0) {
        dispatch(
          updateWSrequestLog(
            WSRequestlogID,
            fileID,
            JSON.stringify(CCPaymentResponse),
            "PaymentLocation-Download Policy Screen",
            "",
            "ProcessCCPayment",
            CCPaymentResponse.transactionID.toString(),
            userID,
          ),
        );
      }
    }
  }, [CCPaymentResponse, WSRequestlogID]);

  useEffect(() => {
    setValue(`CCType`, "defaultCC");
    setValue(`paymentType`, "1");
  }, []);

  useEffect(() => {
    if (formValues?.AddNewCCTempVaultkey) {
      payNowRef?.current && payNowRef?.current?.click(); //this is added becuase on first click hosted toekn will be undefined,so once value is set we click again
    }
  }, [formValues?.AddNewCCTempVaultkey]);

  const amountExceedingFirmCredit =
    dealtypeID === 1
      ? dueAmount > lawyerDetails?.lawyer?.creditLimitResidential
      : dueAmount > lawyerDetails?.lawyer?.creditLimitCommercial;

  useEffect(() => {
    if (amountExceedingFirmCredit && formValues?.paymentType === "2") {
      setValue("paymentType", "1");
    }
  }, [amountExceedingFirmCredit, formValues?.paymentType, setValue]);

  return (
    <>
      <ToastContainer />
      <div>
        <div className="border-[#d9d9d9] border-[1px] flex flex-col font-open-sans rounded-[2px] mt-10 mb-10">
          <div className="bg-[#FAE094] border-[#dbdada] border-b flex flex-row font-semibold leading-[21.79px] px-[32px] py-[14px]  w-full">
            <div>{t("MethodofPayment")}</div>
          </div>

          <div className="inline-flex font-[400] space-x-1 py-6 pb-0">
            <FormInputRadio
              fieldName="paymentType"
              id="paymentType"
              testId="paymentType"
              register={register}
              handleChange={handleChange}
              ariaLabel="paymentType"
              labelClasses="questionnaire font-semibold  mr-4"
              answerOption={[
                {
                  id: "paymentType",
                  value: "1",
                  label: t("PaynowbyCreditcard"),
                  name: "paymentType",
                },
                {
                  id: "paymentType",
                  value: "2",
                  label: t("OnAccount(Self-administered)"),
                  name: "paymentType",
                  disabled: amountExceedingFirmCredit,
                },
              ]}
            />
            <span className="ml--30">
              <Tooltip text={t("onAccntToolTip")} />
            </span>
          </div>

          {formValues?.paymentType === "1" && (
            <>
              <div className="px-[32px]">
                <div className="flex flex-row font-[400]   w-full">
                  <div className="ml-4" />
                  <div className="border-bottom-line-thick font-semibold  w-[15%]">
                    <p className="pb-[8px] pt-[16px]">{t("FirmLimit")}</p>
                  </div>
                  <div className="border-bottom-line-thick w-[12%]">
                    <p className="pb-[8px] pt-[16px]">
                      :{" "}
                      {dealtypeID === 1
                        ? lawyerDetails?.lawyer?.creditLimitResidential
                        : lawyerDetails?.lawyer?.creditLimitCommercial}
                    </p>
                  </div>
                </div>
              </div>
              {amountExceedingFirmCredit && (
                    <>
                      <div className="px-[32px]">
                        <div className="flex flex-row font-[400]   w-full">
                          <div className="ml-4" />
                          <div className="border-bottom-line-thick font-semibold  w-[15%]">
                            <p className="pb-[8px] pt-[16px]">
                              {t("CurrentBalanceInvoice")}
                            </p>
                          </div>
                          <div className="border-bottom-line-thick w-[12%]">
                            <p className="pb-[8px] pt-[16px]">: {dueAmount}</p>
                          </div>
                        </div>
                      </div>
                      <div className="pl-5 mt-4" style={{ color: "red" }}>
                        {t("FirmCreditWarningMessage")}
                      </div>
                    </>
                  )}
              <div className="inline-flex font-[400]  space-x-1 py-6">
                <FormInputRadio
                  fieldName="CCType"
                  id="CCType"
                  testId="CCType"
                  register={register}
                  handleChange={handleChange}
                  ariaLabel=" Have you received a quote for this order?"
                  labelClasses="questionnaire font-semibold  mr-4"
                  answerOption={[
                    {
                      id: "CCType",
                      value: "defaultCC",
                      label: t("UseDefaultCreditCard"),
                      name: "CCType",
                    },
                    {
                      id: "CCType",
                      value: "differentCC",
                      label: t("UseDifferentCreditcard"),
                      name: "CCType",
                    },
                  ]}
                />
              </div>
              {formValues?.CCType === "defaultCC" && (
                <div className="px-[32px] gap-[10px] inline-flex pl-12">
                  <div className="w-[736px] input-container">
                    <label
                      htmlFor="regular-input"
                      className="block font-semibold input-label mb-2"
                    >
                      {t("CreditCardNumber")}
                    </label>
                    <input
                      className="opacity-5"
                      type="text"
                      {...register(`defaultCCNumber`)}
                      disabled={true}
                    />
                    <svg
                      className="-translate-y-1/2 absolute input-icon marginTopLeft transform"
                      width="25"
                      height="25"
                      fill="none"
                    >
                      <path
                        d="M20.404 11.428s.33 1.614.403 1.953h-1.45c.144-.387.695-1.888.695-1.888-.009.013.143-.395.23-.647l.122.582ZM25 4.86v15.277c0 1.15-.933 2.084-2.083 2.084H2.083A2.084 2.084 0 0 1 0 20.138V4.862c0-1.15.933-2.084 2.083-2.084h20.834c1.15 0 2.083.933 2.083 2.084ZM6.619 15.763l2.743-6.736H7.517l-1.705 4.601-.187-.933-.608-3.1c-.1-.429-.408-.55-.79-.568H1.42l-.03.135a6.888 6.888 0 0 1 1.831.742l1.554 5.86H6.62Zm4.097.01 1.094-6.746h-1.745l-1.09 6.745h1.741Zm6.072-2.206c.009-.768-.46-1.354-1.463-1.836-.611-.308-.985-.516-.985-.833.009-.287.317-.582 1.003-.582a2.99 2.99 0 0 1 1.298.256l.156.074.239-1.458a4.335 4.335 0 0 0-1.563-.287c-1.723 0-2.934.92-2.943 2.231-.013.968.868 1.507 1.528 1.832.673.33.903.547.903.838-.009.451-.547.66-1.046.66-.694 0-1.068-.11-1.636-.36l-.23-.11-.243 1.515c.408.187 1.163.352 1.944.36 1.832.005 3.025-.902 3.038-2.3Zm6.129 2.205L21.51 9.027h-1.35c-.416 0-.733.122-.91.56l-2.592 6.185h1.832l.364-1.011h2.24c.052.239.208 1.011.208 1.011h1.615Z"
                        fill="#000"
                      ></path>
                    </svg>
                  </div>
                  <div className="size__xxs input-container">
                    <label
                      htmlFor="regular-input"
                      className="block font-semibold input-label mb-2 w-[150px]"
                    >
                      {t("ExpiryDate")}
                    </label>
                    <input
                      className="opacity-5"
                      type="text"
                      {...register(`defaultCCExpiryDate`)}
                      disabled={true}
                    ></input>
                    <input type="hidden" {...register(`defaultCCVaultKey`)} />
                  </div>
                </div>
              )}

              {/* different credit card */}
              {formValues?.CCType === "differentCC" && (
                <div className="px-[32px] pl-12">
                  {diffCCdetails
                    //?.filter((x) => x.cardnumber !== undefined && x.isAllDealType===false)
                    ?.map((item, index) => {
                      const values =
                        formValues.credit && formValues.credit[index];
                      // && values?.isAllDealType===false
                      return (
                        <tr className="!h-[70px] bg-transparent font-[400] items-center leading-[21.79px] pl-[24px] pr-[38px] ">
                          <td>
                            <div className="font-[400] mr--30">
                              <FormInputRadio
                                fieldName={`diffCCRadio`}
                                id="diffCCRadio"
                                testId="diffCCRadio"
                                register={register}
                                handleChange={handleChange}
                                labelClasses="questionnaire font-semibold"
                                answerOption={[
                                  {
                                    id: "CCType",
                                    value: index,
                                    //label: t("UseDefaultCreditCard"),
                                    name: "diffCCRadio",
                                  },
                                ]}
                              />
                            </div>
                          </td>
                          <td
                            className="pb-[6px] pt-[16px] py-[14px]"
                            style={{ height: 60 }}
                          >
                            <div className="custom__add-section">
                              <div className="gap-[10px] inline-flex">
                                {
                                  // ccDetails !== undefined &&
                                  //   ccDetails.length > 0 &&
                                  //   values?.cardnumber !== undefined &&
                                  <>
                                    <div className="!w-[130px] input-container mt-10 relative">
                                      <p className="font-semibold">
                                        {t("CreditCard")} {index + 1}
                                      </p>
                                    </div>
                                    <div className="w-[736px] input-container">
                                      <label
                                        htmlFor="regular-input"
                                        className="block font-semibold input-label mb-2"
                                      >
                                        {t("CreditCardNumber")}
                                      </label>
                                      <input
                                        className="opacity-5"
                                        type="text"
                                        {...register(
                                          `credit.${index}.cardnumber`,
                                        )}
                                        value={item?.maskedCardNumber}
                                        name={`credit.${index}.cardnumber`}
                                        disabled={true}
                                      />
                                      <svg
                                        class="-translate-y-1/2 absolute input-icon marginTopLeft transform"
                                        width="25"
                                        height="25"
                                        fill="none"
                                      >
                                        <path
                                          d="M20.404 11.428s.33 1.614.403 1.953h-1.45c.144-.387.695-1.888.695-1.888-.009.013.143-.395.23-.647l.122.582ZM25 4.86v15.277c0 1.15-.933 2.084-2.083 2.084H2.083A2.084 2.084 0 0 1 0 20.138V4.862c0-1.15.933-2.084 2.083-2.084h20.834c1.15 0 2.083.933 2.083 2.084ZM6.619 15.763l2.743-6.736H7.517l-1.705 4.601-.187-.933-.608-3.1c-.1-.429-.408-.55-.79-.568H1.42l-.03.135a6.888 6.888 0 0 1 1.831.742l1.554 5.86H6.62Zm4.097.01 1.094-6.746h-1.745l-1.09 6.745h1.741Zm6.072-2.206c.009-.768-.46-1.354-1.463-1.836-.611-.308-.985-.516-.985-.833.009-.287.317-.582 1.003-.582a2.99 2.99 0 0 1 1.298.256l.156.074.239-1.458a4.335 4.335 0 0 0-1.563-.287c-1.723 0-2.934.92-2.943 2.231-.013.968.868 1.507 1.528 1.832.673.33.903.547.903.838-.009.451-.547.66-1.046.66-.694 0-1.068-.11-1.636-.36l-.23-.11-.243 1.515c.408.187 1.163.352 1.944.36 1.832.005 3.025-.902 3.038-2.3Zm6.129 2.205L21.51 9.027h-1.35c-.416 0-.733.122-.91.56l-2.592 6.185h1.832l.364-1.011h2.24c.052.239.208 1.011.208 1.011h1.615Z"
                                          fill="#000"
                                        ></path>
                                      </svg>
                                    </div>
                                    <div className="size__xxs input-container">
                                      <label
                                        htmlFor="regular-input"
                                        className="block font-semibold input-label mb-2 w-[150px]"
                                      >
                                        {t("ExpiryDate")}
                                      </label>
                                      <input
                                        className="opacity-5"
                                        type="text"
                                        {...register(`credit.${index}.expDate`)}
                                        name={`credit.${index}.expDate`}
                                        //  value={item?.expDate}
                                        value={
                                          item?.expiryMonth +
                                          "/" +
                                          item?.expiryYear
                                        }
                                        disabled={true}
                                      ></input>
                                    </div>
                                  </>
                                }
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  <input type="hidden" {...register(`diffCCVaultKey`)} />
                  <div className="">
                    <tr className="!h-[70px]  font-[400] items-center leading-[21.79px] pl-[24px] pr-[38px] ">
                      <td>
                        <div className="font-[400] mr--30">
                          <FormInputRadio
                            fieldName={`AddnewCC`}
                            id="AddnewCC"
                            testId="AddnewCC"
                            register={register}
                            handleChange={handleChange}
                            ariaLabel="AddnewCC"
                            answerOption={[
                              {
                                id: "CCType",
                                value: `AddnewCC.${2}`,
                                //label: "Add new credit card",
                                name: "AddnewCC",
                              },
                            ]}
                          />
                        </div>
                      </td>
                      <td
                        className="pb-[6px] pt-[16px] py-[14px]"
                        style={{ height: 60 }}
                      >
                        <div className="gap-[10px] inline-flex">
                          <div className="!w-max input-container mt-[25px] relative">
                            <p className="font-semibold">
                              {t("AddnewCClabel")}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </div>
                  {addNewCreditCard && (
                    <>
                      <div className="flex flex row mt-2 ml-8 mb--12px">
                        <div className="w-auto input-container pr-[130px] ml-1">
                          <label
                            htmlFor="regular-input"
                            className="block font-semibold input-label mb-2"
                          >
                            {t("CreditCardNumber")}
                          </label>
                        </div>
                        <div className="w-auto input-container pr-4">
                          <label
                            htmlFor="regular-input"
                            className="block font-semibold input-label mb-2"
                          >
                            {t("ExpiryDate")}
                          </label>
                        </div>
                        <div className="w-auto input-container">
                          <label
                            htmlFor="regular-input"
                            className="block font-semibold input-label mb-2"
                          >
                            CVV
                          </label>
                        </div>
                      </div>
                      <div className="flex flex row ml-6">
                        <PaymentToken
                          id={`monerisFrame${3}`}
                          ref={submittionRef}
                          setTokenKey={(token, binValue) => {
                            handlDropdownChange(`credit.${3}.bin`, binValue);
                            setValue(`credit.${3}.waltID`, token);
                            setValue(`AddNewCCTempVaultkey`, token);
                            trigger(`credit.${3}.waltID`);
                          }}
                          firmIDAndName={firmIDAndName}
                          billing={billing}
                          setCCDailog={setCCDailog}
                          setCreditCardRequest={setCreditCardRequest}
                          values={formValues}
                          billingValues={formValues}
                          index={1}
                          showCClabel={false}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}

              <div className="px-[32px] pl-4">
                <div className="flex flex-row font-[400]   w-full">
                  <div className="border-bottom-line-thick font-semibold  w-max mt-5">
                    <p className="pb-[8px] pt-[16px]">
                      {t("TermsAndCondition")}
                    </p>
                  </div>
                </div>
                <div className="mb-4 text-justify ">{t("CCATermsPara1")}</div>
                <div className="mb-4 text-justify">{t("CCATermsPara2")}</div>
                <div className="mb-4 text-justify">{t("CCATermsPara3")}</div>
                <div className="mb-4 ml--7px">
                  <Checkbox
                    register={register}
                    name={`CCTerms`}
                    classNames={`w-max`}
                    onChange={handleChangeCheckbox}
                    checked={Boolean(formValues?.CCTerms)}
                    label={t("CCATermsPara4")}
                    //disabled={disableWhenSave !== index && disableWhenSave !== -1}
                  />
                </div>
                {CCPaymentResponse && !CCPaymentResponse?.isSuccess && (
                  <div
                    className="mb-4 p-3 text-red-700"
                    role="alert"
                    style={{ marginLeft: -12 }}
                  >
                    <p className="font-semibold">
                      Response - {CCPaymentResponse?.responseResult}, Payment
                      Transaction ID - {CCPaymentResponse?.transactionID}
                    </p>
                  </div>
                )}
                {CCPaymentResponse && CCPaymentResponse?.isSuccess && (
                  <div
                    className="mb-4 p-3 text-green-500"
                    role="alert"
                    style={{ marginLeft: -12 }}
                  >
                    <p className="font-semibold">
                      Payment Successful. 
                      Transaction ID - {CCPaymentResponse?.transactionID}
                    </p>
                  </div>
                )}
                <div className="italic ml--4px text-justify">
                  {t("MonerisNote")}
                </div>
              </div>
            </>
          )}
          <div className="flex flex-row">
            <div className="flex flex-col mt-4 ml-2">
              {formValues?.CCTerms &&
                formValues?.paymentType === "1" &&
                !hasInvoices && (
                  <button
                    //onClick={() => isValid ? setCCDailog(true) : trigger()}
                    ref={payNowRef}
                    onClick={() => {
                      var request = {
                        transactionID: 0,
                        fileID: fileID,
                        CCTransactionLogIds: "",
                        hostedToken:
                          NewCC === true && formValues?.CCType === "differentCC"
                            ? formValues?.AddNewCCTempVaultkey
                            : formValues?.CCType === "differentCC"
                              ? formValues?.diffCCVaultKey
                              : formValues?.defaultCCVaultKey,
                        IssuerID: "",
                        defaultNewCC: false,
                        sourceApp: 1,
                        userID: userID,
                      };
                      if (!request?.hostedToken) {
                        submittionRef?.current &&
                          submittionRef.current.submitdata(`monerisFrame${3}`);
                        return;
                      }
                      dispatch(
                        saveNote(
                          fileID,
                          t("payNowNotes") + new Date().toLocaleString(),
                          userID,
                          -1,
                          null,
                          "PayNowbyCC",
                          false,
                        ),
                      );
                      dispatch(ProcessCCPayment(request, userID, { toast }));
                      dispatch(
                        InsertWSrequestLog(JSON.stringify(request), userID),
                      );
                      return;
                    }}
                    disabled={CCPaymentResponse?.isSuccess || hasInvoices}
                    className="btn__primary flex py-[10px]  mr-2 mb-1 pr-2 pl-2"
                  >
                    <span className="font-sans font-semibold">
                      {t("PayNow")}
                    </span>
                  </button>
                )}
            </div>
            {!hasInvoices && (
              <div className="flex flex-col ">
                <Link to={`/policypickup/${fileID + 100000}`}>
                  <button
                    className="btn__primary px-[16px] py-[9px] mt-4 mb-1"
                    disabled={
                      CCPaymentResponse?.isSuccess ||
                      formValues?.paymentType === "2"
                        ? false
                        : true
                    }
                    onClick={() => {
                      downloadPoliciesClick();
                    }}
                  >
                    {t(pricingInfo?.pricingInfoItems?.length > 1 ? "DownloadPolicies" : "DownloadPolicy")}
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MethodOfPayment;
